import React from 'react'

const DayLoading = () => {
  return <div className="loading-day"></div>
}

export default DayLoading
